export default __webpack_public_path__ + "static/media/Sudip-Samanta.6f1a81e0.jpg";